/**
 * Production-safe logger. Outputs to console in development only.
 * In production builds (NODE_ENV=production), all output is suppressed.
 */
const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  error: isDev ? console.error.bind(console) : () => {},
  warn: isDev ? console.warn.bind(console) : () => {},
  log: isDev ? console.log.bind(console) : () => {},
  debug: isDev ? console.debug.bind(console) : () => {},
};

export default logger;
